<!-- 百科号详细信息 -->
<template>
  <div class='all'>
    <Top :hasShare="false"/>
    <!-- 顶部 -->
    <div class="top">
      <!-- logo -->
      <div class="logo">
        <div class="left">
          <van-image round
                     width="50px"
                     height="50px"
                      fit="cover"
                     :src="$global.imgUrl + info.periodicalLogo" />
        </div>
        <div class="right">
          <div class="title">
            {{info.name}}
          </div>
        </div>
      </div>
      <!-- 主管单位 -->
      <div class="public-item">
        <div class="public-title">
          <span>主管单位</span>
        </div>
        <div class="public-text jianjie-title" v-if="!(info.responsibleDeptList && info.responsibleDeptList.length > 0)">{{info.responsibleDept}}</div>
        <div class="public-text jianjie-title" v-else v-for="(item,index) in info.responsibleDeptList" :key="index">
          <span>{{item.orgName}}</span>
          <van-icon name="arrow" @click="jumpOrg(item)" />
        </div>
        <!-- <div class="public-text jianjie-title"
             v-for="(item,index) in info.responsibleDeptList"
             :key="index">
          <span>
            {{item.orgName}}
          </span>
          <van-icon name="arrow"
                    v-if="item.orgStatus == 1 && item.orgBaseType"
                    @click="jumpOrg(item)" />
        </div> -->
      </div>
      <!-- 主办单位 -->
      <div class="public-item">
        <div class="public-title">
          <span>主办单位</span>
        </div>
        <div class="public-text jianjie-title" v-if="!(info.organizerList && info.organizerList.length > 0)">{{info.organizer}}</div>
        <div class="public-text jianjie-title" v-else v-for="(item,index) in info.organizerList" :key="index">
          <span>{{item.orgName}}</span>
          <van-icon name="arrow" @click="jumpOrg(item)" />
        </div>
        <!-- <div class="public-text jianjie-title"
             v-for="(item,index) in info.organizerList"
             :key="index">
          <span>{{item.orgName}}</span>
          <van-icon name="arrow"
                    v-if="item.orgStatus == 1 && item.orgBaseType"
                    @click="jumpOrg(item)" />
        </div> -->
      </div>
      <!-- 出版单位 -->
      <div class="public-item">
        <div class="public-title">
          <span>出版单位</span>
        </div>
        <div class="public-text jianjie-title" v-if="!(info.publishCompanyList && info.publishCompanyList.length > 0)">{{info.publishCompany}}</div>
        <div class="public-text jianjie-title" v-else v-for="(item,index) in info.publishCompanyList" :key="index">
          <span>{{item.orgName}}</span>
          <van-icon name="arrow" @click="jumpOrg(item)" />
        </div>
      </div>
      <!-- 出版周期 -->
      <div class="public-item">
        <div class="public-title">
          <span>出版周期</span>
        </div>
        <div class="public-text">
          {{ info.publishPeriod | period }}
        </div>
      </div>
      <!-- 收录网站 -->
      <div class="public-item">
        <div class="public-title">
          <span>收录网站</span>
        </div>
        <div class="public-text"
             v-for="(item,index) in info.pd"
             :key="index">
          {{item.name}}
        </div>
      </div>
      <!-- CN -->
      <div class="public-item">
        <div class="public-title">
          <span>CN</span>
        </div>
        <div class="public-text">
          {{info.cn}}
        </div>
      </div>
      <!-- ISSN -->
      <div class="public-item">
        <div class="public-title">
          <span>ISSN</span>
        </div>
        <div class="public-text">
          {{info.issn}}
        </div>
      </div>
      <!-- 国家邮发代号 -->
      <div class="public-item">
        <div class="public-title">
          <span>国内邮发代号</span>
        </div>
        <div class="public-text">
          {{info.codeDomestic}}
        </div>
      </div>
      <!-- 出版地 -->
      <div class="public-item"
           v-if="info.address">
        <div class="public-title">
          <span>出版地</span>
        </div>
        <div class="public-text">
          {{info.address}}
        </div>
      </div>
      <!-- Email -->
      <div class="public-item">
        <div class="public-title">
          <span>Email</span>
        </div>
        <div class="public-text">
          {{info.email}}
        </div>
      </div>
      <!-- 官方网址 -->
      <div class="public-item"
           v-if="info.website">
        <div class="public-title">
          <span>官方网址</span>
        </div>
        <div class="public-text">
          {{info.website}}
        </div>
      </div>
      <!-- 期刊简介 -->
      <div class="public-item"
      v-if="info.periodicalIntro">
        <div class="jianjie-title"
             @click="jumpPerDetail()">
          <span>期刊简介</span>
          <van-icon name="arrow" />
        </div>
        <div class="jianjie-text"
             v-html="info.periodicalIntro">
        </div>
      </div>
      <!-- 征稿启事 -->
      <div class="public-item"
           v-if="info.notice">
        <div class="jianjie-title"
             @click="jumpNoticeDetail()">
          <span>征稿启事</span>
          <van-icon name="arrow" />
        </div>
        <div class="jianjie-text"
             v-html="info.notice">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/views/mobileView/detail/components/Header.vue'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Top
  },
  filters: {
    period(num) {
      if (num == 1) {
        return `年刊`;
      } else if (num == 2) {
        return `半年刊`;
      } else if (num == 3) {
        return `季刊`;
      } else if (num == 4) {
        return `双月刊`;
      } else if (num == 5) {
        return `月刊`;
      } else if (num == 6) {
        return `半月刊`;
      } else if (num == 7) {
        return `旬刊`;
      } else if (num == 8) {
        return `周刊`;
      } else if (num == 9) {
        return `周二刊`;
      } else {
        return ``;
      }
      // 1 年刊 2半年刊 3 季刊 4 双月刊 5 月刊 6 半月刊 7 旬刊 8 周刊 9 周二刊
    },
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      info: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 机构类型
    orgType(data) {
      switch (data)
      {
        case 1:
          console.log('出版单位')
          data = '/magazine'
          break;
        case 2:
          console.log('行业组织')
          data = '/association'
          break;
        case 3:
          console.log('科研机构')
          data = '/appusesinstitutions'
          break;
        case 4:
          console.log('政府机构')
          data = '/government'
          break;
        case 5:
          console.log('院校')
          data = '/university'
          break;
        case 6:
          console.log('其他')
          data = '/other'
          break;
      }
      return data
    },
    // 跳转各机构 
    jumpOrg(data) {
      let out = this.$route.query.out
      let web = 'web'
      out ? this.$router.push(`/appusesinstitutions?orgId=${data.orgId}&app=${web}&out=${out}`) :
            this.$router.push(`/appusesinstitutions?orgId=${data.orgId}&app=${web}`)
    },
    // 跳转征稿启事
    jumpNoticeDetail() {
      this.$router.push({
        path: '/collectionArticle',
        query: {
          userId: this.$route.query.userId
        }
      })
    },
    // 跳转期刊简介
    jumpPerDetail() {
      this.$router.push({
        path: '/perDetail',
        query: {
          userId: this.$route.query.userId
        }
      })
    },
    //this.$apis.hundredServe.bkDetailList
    getInfo() {
      this.$apis.hundredServe.bkDetailList({
        id: this.$route.query.userId
      }).then((result) => {
        console.log(result)
        this.info = result.periodicalInfo
      }).catch((err) => {
        console.log(err)
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
}
</script>
<style lang='scss' scoped>
.all {
  background: #e5e5e5;
  margin-top: 70px;
  .top {
    overflow: hidden;
    padding: 0 16px 26px 16px;
    background-color: #fff;
    .logo {
      margin-top: 14px;
      display: flex;
      align-items: center;
      .left {
        margin-right: 10px;
      }
      .right {
        .title {
          font-size: 15px;
          font-family: PingFang;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
}
.public-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}
.public-jianjie {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}
.jianjie-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.jianjie-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.public-item {
  margin-top: 20px;
}
.public-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  span {
    margin-right: 10px;
  }
  .per-name {
    padding: 0 8px;
    display: inline-block;
    border: 1px dashed #4585f5;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #4459d3;
  }
}
::v-deep .van-image--round {
  vertical-align: middle;
}
::v-deep .jianjie-text p font {
  color: #000000 ;
  font-size: 15px;
}
::v-deep .jianjie-text h3 font {
  color: #000000 ;
  font-size: 15px;
}
</style>